module.exports = __webpack_public_path__ + "static/young-leader-photo-naman_sachdeva-d235d5dc42a753254783c3f4ece74c59.jpg";